import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import { OrderLanguage } from "../../../utils/Languages";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import MainPagination from "../../Common/MainPagination";

const getRequestStatus = (item) => {
  const statuses =
    item?.tickets?.flatMap((ticket) =>
      ticket.attendees?.map((attendee) => attendee.cancelRequestStatus)
    ) || [];

  const filtered = statuses.filter(Boolean);
  if (!filtered.length) {
    return "Pending";
  }
  if (filtered.every((status) => status === "rejected")) {
    return "Rejected";
  }
  if (filtered.every((status) => status === "refunded")) {
    return "Refunded";
  }
  if (filtered.some((status) => status === "approved")) {
    return "Approved";
  }
  return "Pending";
};

const getStatusClassName = (status) => {
  switch (status) {
    case "Rejected":
      return "event-cancel-request-status is-rejected";
    case "Refunded":
    case "Approved":
      return "event-cancel-request-status is-success";
    default:
      return "event-cancel-request-status is-pending";
  }
};

const getAttendeeCount = (item) =>
  item.tickets?.flatMap((ticket) =>
    ticket.attendees?.filter(
      (attendee) => attendee.cancelRequestStatus !== "null"
    )
  ).length || 0;

const CancleRequests = ({
  list,
  isLoading,
  isError,
  getCancleTicketRequests,
}) => {
  const location = useLocation();
  const query = new URLSearchParams(window.location.search);
  const eventName =
    query.get("event") !== null ? `?event=${query.get("event")}` : "";
  const items = list?.data?.itemsList || [];

  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-attendees-cancel-panel">
        <div className="event-attendees-table-wrap">
          {list !== null ? (
            items.length > 0 ? (
              <MainPagination
                getEventsMethod={getCancleTicketRequests}
                MainData={list}
              >
                <table
                  className="event-attendees-table event-cancel-requests-table"
                  aria-label="Cancel ticket requests"
                >
                  <thead>
                    <tr>
                      <th scope="col">
                        {OrderLanguage.CancelRequests.list.Columns.name}
                      </th>
                      <th scope="col">
                        {OrderLanguage.CancelRequests.list.Columns.email}
                      </th>
                      <th scope="col">
                        {OrderLanguage.CancelRequests.list.Columns.date}
                      </th>
                      <th scope="col">
                        {OrderLanguage.CancelRequests.list.Columns.attendant}
                      </th>
                      <th scope="col">
                        {OrderLanguage.CancelRequests.list.Columns.price}
                      </th>
                      <th scope="col">
                        {
                          OrderLanguage.CancelRequests.list.Columns
                            .requestStatus
                        }
                      </th>
                      <th scope="col" className="is-action">
                        {OrderLanguage.CancelRequests.list.Columns.action}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => {
                      const status = getRequestStatus(item);
                      const cancelDate =
                        item.tickets?.[0]?.attendees?.[0]?.cancelRequestDate;

                      return (
                        <tr
                          key={item._id || index}
                          className="event-attendees-row event-cancel-requests-row"
                        >
                          <td>
                            {item.user?.firstName} {item.user?.lastName}
                          </td>
                          <td>{item.user?.email}</td>
                          <td>
                            {cancelDate
                              ? moment(cancelDate).format("DD-MM-YYYY")
                              : moment().format("DD-MM-YYYY")}
                          </td>
                          <td>{getAttendeeCount(item)}</td>
                          <td className="event-orders-cell-price">
                            USD {Number(item?.userRefundAmount || 0).toFixed(2)}
                          </td>
                          <td>
                            <span className={getStatusClassName(status)}>
                              {status}
                            </span>
                          </td>
                          <td className="event-attendees-cell-actions">
                            <Link
                              className="event-orders-action-btn"
                              to={`/payment/refund/${item?.tickets?.[0]?.id}/${
                                item?._id
                              }?redirectUrl=${location.pathname}${eventName}`}
                            >
                              Pay
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </MainPagination>
            ) : (
              <div className="event-attendees-empty-state">
                No cancel ticket requests found
              </div>
            )
          ) : null}
        </div>
      </div>
    </MainComponentWrapper>
  );
};

export default CancleRequests;
